
export const defaultLocale = "th";
export const currency = "THB";
export const localeOptions=[
    {id:'th',name:'Thai'},    
    {id:'en',name:'English'}
];
export const registCompAdv = 5000
export const relsCost = 450
export const reqrCost = 450
export const reuCost = 900
export const transferCost = 100
export const qtyList = [1,2,3,4,5,6,7,8,9,10,15,20,30,50]
export const inputLimitUSD = 10000
// export const contSize = [
//     {text : "20'GP" , value : "20GP"},
//     {text : "20'DC" , value : "20DC"},
//     {text : "20'ST" , value : "20ST"},
//     {text : "40'GP" , value : "40GP"},
//     {text : "40'ST" , value : "40ST"},
//     {text : "40'HC" , value : "40HC"},
//     {text : "40'HQ" , value : "40HQ"},
//     {text : "45'GP" , value : "45GP"},
//     {text : "45'G1" , value : "45G1"},
// ]

// GP(General Purpose) = DV(Dry Van) = DC(Dry Container) = ST(STandard)
// HC (High Cube) = HQ (High Qube)
export const contSize = [
    {text : "L20 Feet" , value : "L20"},
    {text : "L40 Feet" , value : "L40"},
    {text : "L40 Feet-HC" , value : "L40HC"},
    {text : "L20 Feet-NOR" , value : "L20NOR"},      
    {text : "L40 Feet-NOR" , value : "L40NOR"},
    {text : "L20 Feet-HC" , value : "L20HC"},    
    {text : "L45 Feet" , value : "L45"},
    {text : "L45 Feet-HC" , value : "L45HC"},
]
export const contType = [
    {text : 'Dry' , value : 'dry'},
    {text : 'Reefer' , value : 'reefer'},
    {text : 'Flat-rack' , value : 'flatRack'},
    {text : 'Open Top' , value : 'openTop'},
    // {text : 'Ventilated' , value : 'vent'}
]
export const contGrade = [
    {text : 'A' , value : 'A'},
    {text : 'B' , value : 'B'},
    {text : 'C' , value : 'C'},
    {text : 'Food' , value : 'F'}
]
export const currencies = [
    {text : 'US Dollar' , value : 'USD'},
    {text : 'Euro' , value : 'EUR'},
    {text : 'Japaness Yen' , value : 'JPY'},
    {text : 'Pound Sterling/British Pound' , value : 'GBP'},
    {text : 'Chinese Yuan' , value : 'CNY'},
    {text : 'Australian Dollar' , value : 'AUD'},
    {text : 'Canadian Dollar' , value : 'CAD'}
]
export const rateBase = [
    {text : 'per TEU, Container' , value : 'TEU'},   
    {text : 'per Size, Container' , value : 'SIZE'},
    {text : 'per Container', value : 'CONT'},
    {text : 'per BL', value : 'BL'},
]
export const teuCont = {
    L20 : 1,
    L40 : 2,
    L40HC : 2,
    L20NOR : 1,
    L40NOR : 2,
    L20HC : 1,
    L45 : 2,
    L45HC : 2
}
export const cancelCustOptions
 = [
    'ไม่ต้องการแล้ว',
    'ข้อมูลผิดพลาด ต้องการสร้างแบบคำร้องขอ อันใหม่แทน',
    'ไม่เข้าใจวิธีการใช้งาน'
]
export const rejAgentOptions
 = [
    'ไม่มีที่ว่าง จองเต็มแล้ว',
    'วันที่ต้องการส่งออก ไม่มีที่ว่าง กรุณาเปลี่ยนวันที่ใหม่ : ____',  
    'ข้อมูลผิดพลาด กรุณาสร้างแบบคำร้องขอ อันใหม่แทน',
]
export const rejCustOptions
 = [
    'เลือกสายเรืออื่นเรียบร้อยแล้ว',
    'เลือกสายเรืออื่น เสนอค่าบริการตำ่กว่า',    
    'เลือกสายเรืออื่น ข้อเสนอดีกว่า',
    'วันที่ส่งออกของสายเรือ ไม่ตรงกับความต้องการ',  
    'เจ้าของสินค้า ยกเลิกการส่งออก',
    'เจ้าของสินค้า ยกเลิกรายการ',
]

